<template>
  <div>
    <v-container max-width="400" flat class="py-12 mx-auto">
      <v-card color="#fff" class="elevation-0">
        <v-row dense>
          <v-col cols="3">
            <v-card
              ref="unitV"
              @click="sessionClick"
              color="#385F73"
              dark
              elevation="0"
            >
              <v-card-title class="title">Engajamento</v-card-title>
              <v-card-subtitle class="text-right headline font-weight-bold">{{
                total_session
              }}</v-card-subtitle>

              <!-- <v-card-actions>
              <v-btn text>View</v-btn>
            </v-card-actions> -->
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card
              @click="financiamentoClick()"
              ref="stockV"
              color="#fff"
              :dark="false"
              elevation="0"
            >
              <v-card-title class="title">Financiamento</v-card-title>

              <v-card-subtitle class="text-right headline font-weight-bold">{{
                total_financiamento
              }}</v-card-subtitle>

              <!-- <v-card-actions>
              <v-btn text>View</v-btn>
            </v-card-actions> -->
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card
              ref="valueV"
              @click="consorcioClick()"
              color="#fff"
              :dark="false"
              elevation="0"
            >
              <v-card-title class="title">Consórcio</v-card-title>

              <v-card-subtitle class="text-right headline font-weight-bold">{{
                total_consorcio
              }}</v-card-subtitle>

              <!-- <v-card-actions>
              <v-btn text>View</v-btn>
            </v-card-actions> -->
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card
              ref="leadsV"
              @click="leadsClick()"
              color="#fff"
              :dark="false"
              elevation="0"
            >
              <v-card-title class="title">Leads</v-card-title>

              <v-card-subtitle class="text-right headline font-weight-bold">{{
                total_leads
              }}</v-card-subtitle>

              <!-- <v-card-actions>
              <v-btn text>View</v-btn>
            </v-card-actions> -->
            </v-card>
          </v-col>
        </v-row>
        <LineChart
          id="chartMain"
          titleChart=""
          titleY=""
          :chartSeries="series"
          :xAxis="categoria"
          :plotLabel="true"
          :ploMouse="true"
          :idChart="defaultChart"
        ></LineChart>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import { ChartEvents } from "./components/chartEvents";
import { mapGetters } from "vuex";
import firebase from "@/plugins/firebase";

export default {
  name: "lineChart",

  components: {
    highcharts: Chart,
    LineChart: () => import("./components/LineChart"),
    chartCards: () => import("./components/ChartCards")
  },

  data() {
    return {
      session_value: [],
      session_periodo: [],
      total_session: 0,
      total_consorcio: 0,
      total_financiamento: 0,
      total_leads: 0,
      toolBar: false,
      defaultChart: "updateLineChart",
      series: {
        name: "Usuarios",
        data: [],
        color: "#840101"
      },
      categoria: []
    };
  },
  methods: {
    sessionClick(e) {
      this.$refs.unitV.dark = true;
      this.$refs.unitV.color = "#385F73";

      this.$refs.valueV.dark = false;
      this.$refs.valueV.color = "#fff";

      this.$refs.stockV.dark = false;
      this.$refs.stockV.color = "#fff";

      this.$refs.leadsV.dark = false;
      this.$refs.leadsV.color = "#fff";

      ChartEvents.$emit(this.defaultChart, {
        newData: [
          {
            name: "Engajamento",
            data: this.session_value,
            color: "#840101"
          }
        ]
      });
    },

    async consorcioClick() {
      const callFuncCon = this.getConsorcio;

      var p1 = [];
      var temp_cons = 0;
      var tmpCategoria = [];
      callFuncCon.forEach(a => {
        temp_cons += Number(a.total_simulado);
        p1.push(Number(a.total_simulado));
        tmpCategoria.push(a.periodo_format);
      });

      await Promise.all(p1, tmpCategoria).then(() => {
        this.total_consorcio = temp_cons;
        this.$refs.unitV.dark = false;
        this.$refs.unitV.color = "#fff";

        this.$refs.valueV.dark = true;
        this.$refs.valueV.color = "#385F73";

        this.$refs.leadsV.dark = false;
        this.$refs.leadsV.color = "#fff";

        this.$refs.stockV.dark = false;
        this.$refs.stockV.color = "#fff";
        ChartEvents.$emit(this.defaultChart, {
          newData: [
            {
              name: "Consórcios",
              data: p1,
              color: "#018431"
            }
          ],
          categoria: tmpCategoria
        });
      });
    },

    async financiamentoClick() {
      const callFuncFin = this.getFinanciamento;

      var p1 = [];
      var temp_cons = 0;
      var tmpCategoria = [];
      // this.categoria = [];
      callFuncFin.forEach(a => {
        temp_cons += Number(a.total_simulado);
        p1.push(Number(a.total_simulado));
        tmpCategoria.push(a.periodo_format);
      });

      await Promise.all(p1, tmpCategoria).then(() => {
        this.$refs.unitV.dark = false;
        this.$refs.unitV.color = "#fff";

        this.$refs.valueV.dark = false;
        this.$refs.valueV.color = "#fff";

        this.$refs.leadsV.dark = false;
        this.$refs.leadsV.color = "#fff";

        this.$refs.stockV.dark = true;
        this.$refs.stockV.color = "#385F73";
        this.total_financiamento = temp_cons;
        ChartEvents.$emit(this.defaultChart, {
          newData: [
            {
              name: "Financiamentos",
              data: p1,
              color: "#090184"
            }
          ],
          categoria: tmpCategoria
        });
      });
    },

    async leadsClick() {
      const callFuncFin = this.getLeads;

      var p1 = [];
      var temp_cons = 0;
      var tmpCategoria = [];
      // this.categoria = [];
      callFuncFin.forEach(a => {
        temp_cons += Number(a.total_simulado);
        p1.push(Number(a.total_simulado));
        tmpCategoria.push(a.periodo_format);
      });

      await Promise.all(p1, tmpCategoria).then(() => {
        this.$refs.unitV.dark = false;
        this.$refs.unitV.color = "#fff";

        this.$refs.valueV.dark = false;
        this.$refs.valueV.color = "#fff";

        this.$refs.stockV.dark = false;
        this.$refs.stockV.color = "#fff";

        this.$refs.leadsV.dark = true;
        this.$refs.leadsV.color = "#385F73";
        this.total_leads = temp_cons;
        ChartEvents.$emit(this.defaultChart, {
          newData: [
            {
              name: "Leads",
              data: p1,
              color: "#090184"
            }
          ],
          categoria: tmpCategoria
        });
      });
    },

    updateCardFin() {
      const callFuncFin = this.getFinanciamento;
      this.total_financiamento = 0;

      callFuncFin.forEach(a => {
        this.total_financiamento += Number(a.total_simulado);
      });
    },

    updateCardCon() {
      const callFuncCon = this.getConsorcio;
      this.total_consorcio = 0;
      callFuncCon.forEach(a => {
        this.total_consorcio += Number(a.total_simulado);
      });
    },

    updateCardLeads() {
      const callFuncCon = this.getLeads;
      this.total_leads = 0;
      callFuncCon.forEach(a => {
        this.total_leads += Number(a.total_simulado);
      });
    },

    async updateData() {
      var temp_sess = 0;
      var p1 = [];
      const callFunc = this.getSession;
      var tmpCategoria = [];

      callFunc.forEach(a => {
        temp_sess += Number(a.user_session);
        p1.push(Number(a.user_session));
        tmpCategoria.push(a.periodo_format);
      });

      await Promise.all(p1, tmpCategoria).then(() => {
        this.total_session = temp_sess;
        this.session_value = p1;
        // this.categoria = tmpCategoria;
        ChartEvents.$emit(this.defaultChart, {
          newData: [
            {
              name: "Engajamento",
              data: this.session_value,
              color: "#840101"
            }
          ],
          categoria: tmpCategoria
        });
      });
    }
  },

  computed: {
    ...mapGetters("appAnalytics", [
      "getSession",
      "getFinanciamento",
      "getConsorcio",
      "getLeads"
    ])
  },

  watch: {
    getSession(m, v) {
      this.updateData();
    },
    getFinanciamento() {
      this.updateCardFin();
    },
    getConsorcio() {
      this.updateCardCon();
    },

    getLeads() {
      this.updateCardLeads();
    }
  },

  updated() {},

  mounted() {}
};
</script>
